var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.49 2 12 2s10 4.49 10 10a10.01 10.01 0 0 1-20 0Zm13.67 1.02.27-.31a1.22 1.22 0 0 0-.1-1.54 14.76 14.76 0 0 0-4.18-2.92 3.29 3.29 0 0 0-.8-.22c-.21 0-.41.05-.6.14-.25.14-.44.35-.55.6-.07.18-.17.7-.17.7-.1.58-.17 1.5-.17 2.53 0 .97.06 1.86.15 2.44l.02.1c.04.2.12.6.21.77.21.4.63.66 1.07.66h.04c.3-.01.9-.26.9-.27a14.74 14.74 0 0 0 3.85-2.62l.06-.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylarge);
export default __webpack_public_path__ + "static/media/play.large.9c8c236af2d47ef72d1deb476700a4d8.svg";
export { ForwardRef as ReactComponent };